import { ethers } from "ethers";
import { useContext } from "react";
import ERC1155ABI from "../contexts/MarketplaceContext/erc1155.json";
import ERC20ABI from "../contexts/MarketplaceContext/erc20.json";
import ERC721ABI from "../contexts/MarketplaceContext/erc721.json";
import { assetContent } from "../store/reducers/asset";
import api, { API_GET_DM_NFT_LIST, API_GET_NFT_LIST } from "../utils/api";
import { marketplaceContext } from "./../contexts/MarketplaceContext/index";

const useListNft = () => {
  const { contract, signer, currencyList, chainId } =
    useContext(marketplaceContext);

  const TypeDefines = {
    OrderComponents: [
      { name: "offerer", type: "address" },
      { name: "taker", type: "address" },
      { name: "method", type: "uint8" },
      { name: "offerItems", type: "OfferItems[]" },
      { name: "calculationItem", type: "CalculationItem[]" },
      { name: "startTime", type: "uint256" },
      { name: "endTime", type: "uint256" },
      { name: "salt", type: "uint256" },
      { name: "counter", type: "uint256" },
    ],
    OfferItems: [
      { name: "itemType", type: "uint8" },
      { name: "token", type: "address" },
      { name: "tokenId", type: "uint256" },
      { name: "tokenAmount", type: "uint256" },
      { name: "recipient", type: "address" },
    ],
    CalculationItem: [
      { name: "itemType", type: "uint8" },
      { name: "token", type: "address" },
      { name: "tokenId", type: "uint256" },
      { name: "tokenAmount", type: "uint256" },
      { name: "recipient", type: "address" },
    ],
  };

  const domain = {
    name: "Marketplace",
    version: "1",
    chainId: chainId,
    verifyingContract: currencyList.MARKET_CONTRACT,
  };

  /**
   * output detail: string (response message, "success" or any error message)
   */
  const listNFT = (sale: any) => {
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signerInfo = provider.getSigner();

      return signerInfo._signTypedData(domain, TypeDefines, sale);
    } catch (e) {
      console.error(e);
      throw e;
    } // 回傳一個 promise
  };

  const buyNFT = async (id: any) => {
    try {
      const response = await api.get(API_GET_NFT_LIST, {
        params: { id },
      });

      const res = "success";
      let buyTypedData = JSON.parse(JSON.stringify(response.data.typeddata));
      let price = ethers.BigNumber.from(0);
      if (
        response.data.currency == "0x0000000000000000000000000000000000000000"
      ) {
        price = ethers.BigNumber.from(
          response.data.price.toLocaleString("fullwide", { useGrouping: false })
        );
      }
      buyTypedData.offerer = await signer.getAddress();
      buyTypedData.method = 1;
      console.log(contract);
      return contract.execute(
        response.data.typeddata,
        response.data.sign,
        buyTypedData,
        "0x",
        { value: price }
      );
    } catch (e) {
      console.error(e);
      throw e;
    }
  };

  const buyDmNFT = async (id: any) => {
    try {
      const response = await api.get(API_GET_DM_NFT_LIST, {
        params: { id },
      });

      const res = "success";
      let buyTypedData = JSON.parse(JSON.stringify(response.data.typeddata));
      let price = ethers.BigNumber.from(0);
      if (
        response.data.currency == "0x0000000000000000000000000000000000000000"
      ) {
        price = ethers.BigNumber.from(
          response.data.price.toLocaleString("fullwide", { useGrouping: false })
        );
      }
      buyTypedData.offerer = await signer.getAddress();
      buyTypedData.taker = "0x0000000000000000000000000000000000000000";
      buyTypedData.method = 1;
      return contract.execute(
        response.data.typeddata,
        response.data.sign,
        buyTypedData,
        "0x",
        { value: price }
      );
    } catch (e) {
      console.error(e);
      throw e;
    }
  };

  const getNFT = async (id: any) => {
    try {
      const response = await api.get(API_GET_NFT_LIST, {
        params: { id },
      });
      // await switchChainId(response["data"]["chain_id"])
      const res = "success";
      return {
        detail: response["data"],
      };
    } catch (e) {
      console.error(e);
      throw e;
    }
  };
  const getDmNFT = async (id: any) => {
    try {
      const response = await api.get(API_GET_DM_NFT_LIST, {
        params: { id },
      });
      await switchChainId(response["data"]["chain_id"]);
      const res = "success";
      console.log(response);
      return {
        detail: response["data"],
      };
    } catch (e) {
      console.error(e);
      throw e;
    }
  };

  const delistNFT = async (id: any) => {
    try {
      const response = await api.get(API_GET_NFT_LIST, {
        params: { id },
      });
      const res = "success";
      return contract.cancelOrder(response["data"]["typeddata"]);
    } catch (e) {
      console.error(e);
      return {
        detail: JSON.stringify(e),
      };
    }
  };
  const delistDmNFT = async (id: any) => {
    try {
      const response = await api.get(API_GET_DM_NFT_LIST, {
        params: { id },
      });

      const res = "success";
      return contract.cancelOrder(response["data"]["typeddata"]);
    } catch (e) {
      console.error(e);
      throw e;
    }
  };

  const approveERC721 = async (erc721Address: any) => {
    try {
      const res = "success";
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signerInfo = provider.getSigner();
      const contract = new ethers.Contract(
        erc721Address,
        JSON.stringify(ERC721ABI),
        signerInfo
      );
      return contract.setApprovalForAll(currencyList.DELEGATE_CONTRACT, true);
    } catch (e) {
      console.error(e);
      throw e;
    }
  };

  const approveERC20 = async (erc20Address: any) => {
    try {
      const res = "success";
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signerInfo = provider.getSigner();
      const contract = new ethers.Contract(
        erc20Address,
        JSON.stringify(ERC20ABI),
        signerInfo
      );
      return contract.approve(
        currencyList.DELEGATE_CONTRACT,
        "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"
      );
    } catch (e) {
      console.error(e);
      throw e;
    }
  };

  const isApproveForAllERC721 = async (erc721Address: any) => {
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signerInfo = provider.getSigner();
      const owner = await signer.getAddress();
      const contract = new ethers.Contract(
        erc721Address,
        JSON.stringify(ERC721ABI),
        signerInfo
      );
      const availability = await contract.isApprovedForAll(
        owner,
        currencyList.DELEGATE_CONTRACT
      );

      return {
        detail: availability as boolean,
      };
    } catch (e) {
      console.error(e);
      throw e;
    }
  };

  const isApproveERC20 = async (erc20Address: any) => {
    try {
      if (erc20Address == currencyList.ETH_CONTRACT)
        return { detail: 2 ** 256 - 1 };
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signerInfo = provider.getSigner();
      const owner = await signer.getAddress();
      const contract = new ethers.Contract(
        erc20Address,
        JSON.stringify(ERC20ABI),
        signerInfo
      );
      const availability = await contract.allowance(
        owner,
        currencyList.DELEGATE_CONTRACT
      );

      return {
        detail: availability as number,
      };
    } catch (e) {
      console.error(e);
      throw e;
    }
  };

  const hashOrder = async (typeddata: any) => {
    try {
      const hash = await contract.hashOrder(typeddata);
      return {
        detail: hash,
      };
    } catch (e) {
      console.error(e);
      throw e;
    }
  };

  const checkERC721owner = async (erc721Address: any, tokenId: number) => {
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signerInfo = provider.getSigner();
      const owner = await signer.getAddress();
      const contract = new ethers.Contract(
        erc721Address,
        JSON.stringify(ERC721ABI),
        signerInfo
      );
      const tokenOwner = await contract.ownerOf(tokenId);

      if (owner == tokenOwner) {
        return {
          detail: true,
        };
      } else {
        return {
          detail: false,
        };
      }
    } catch (e) {
      console.error(e);
      throw e;
    }
  };

  const checkERC1155owner = async (erc1155Address: any, tokenId: number) => {
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signerInfo = provider.getSigner();
      const owner = await signer.getAddress();
      const contract = new ethers.Contract(
        erc1155Address,
        JSON.stringify(ERC1155ABI),
        signerInfo
      );
      const tokenBalance = await contract.balanceOf(owner, tokenId);

      if (tokenBalance >= 1) {
        return {
          detail: true,
        };
      } else {
        return {
          detail: false,
        };
      }
    } catch (e) {
      console.error(e);
      throw e;
    }
  };
  const checkAssetChainId = (asset: assetContent) => {
    console.log("asset: ", asset);
    if (asset.permalink.includes("https://testnets.opensea.io/assets/goerli")) {
      return "0x5";
    } else if (asset.permalink.includes("https://opensea.io/assets/sepolia")) {
      return "0xaa36a7";
    } else if (asset.permalink.includes("https://opensea.io/assets/matic")) {
      return "0x89";
    } else if (asset.permalink.includes("https://opensea.io/assets/ethereum")) {
      return "0x1";
    } else {
      throw "error chainId";
    }
  };
  const checkChainId = async (asset: assetContent) => {
    if (asset.permalink.includes("https://testnets.opensea.io/assets/goerli")) {
      await switchChainId("0x5");
    } else if (asset.permalink.includes("https://opensea.io/assets/sepolia")) {
      await switchChainId("0xaa36a7");
    } else if (asset.permalink.includes("https://opensea.io/assets/matic")) {
      await switchChainId("0x89");
    } else if (asset.permalink.includes("https://opensea.io/assets/ethereum")) {
      await switchChainId("0x1");
    }
  };
  const switchChainId = async (chainId: string) => {
    try {
      await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: chainId }],
      });
    } catch (switchError) {
      // This error code indicates that the chain has not been added to MetaMask.
      if (switchError.code === 4902) {
        // Do something
      }
      throw switchError;
    }
  };

  return {
    listNFT,
    buyNFT,
    buyDmNFT,
    getNFT,
    getDmNFT,
    approveERC721,
    approveERC20,
    isApproveForAllERC721,
    isApproveERC20,
    hashOrder,
    delistNFT,
    delistDmNFT,
    checkERC721owner,
    checkERC1155owner,
    checkChainId,
    switchChainId,
    checkAssetChainId,
  };
};

export default useListNft;
